const translations = {
    map: 'map',
    split: 'split',
    table: 'table'
};

export default translations;
